import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CoursesService } from 'src/app/core/services/courses-service';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { FavouriteCourse } from 'src/app/model/course-favourite';
import { ConfigurationService } from 'src/app/core/services/configuration.service';

@Component({
  selector: 'ms-favourites-courses-list',
  templateUrl: './favourites-courses-list.component.html',
  styleUrls: ['./favourites-courses-list.component.scss']
})
export class FavouritesCoursesListComponent implements OnInit {

  isLoading: boolean;
  noFavouritesCourses: boolean;
  displayedColumns: string[] = ['courseCode'];
  FavouritesCourses: MatTableDataSource<FavouriteCourse> = new MatTableDataSource<FavouriteCourse>();

  constructor(
    private courseService: CoursesService,
    public configurationService: ConfigurationService,
  ) { }

  ngOnInit():void
  {
  this.isLoading = true;

  this.configurationService.getAllFavouriteCoursesByLogin("webmaster@microarea.it")
  .then((res) => {
    if(res.Result && res.Content){
    console.log("res.Content",res.Content);

this.FavouritesCourses.data= res.Content;
this.noFavouritesCourses = res.Content.length==0;
    }
    this.isLoading = false
  })
  .catch(err => {
    this.isLoading = false
  })
}

//async getCourseDetail(courseID)
//{console.log("courseID",courseID)

//var coursesRes = await this.courseService.getAllCourses(courseID)
//if(coursesRes.Result && coursesRes.Content){
  //console.log("coursesRes.Content",coursesRes.Content)
//}
//}
}
